<template />

<script setup lang="ts">
import { onBeforeUnmount, onMounted, watch } from 'vue';

const props = defineProps<{ source?: string | null }>();
let element: HTMLStyleElement | null = null;

function render(source: string | null | undefined): void {
  if (!element) return;
  element.textContent = source ?? '';
}

onMounted(() => {
  element = document.createElement('style');
  element.dataset.themeStyleSheet = 'runtime';
  document.head.append(element);
  render(props.source);
});
watch(() => props.source, render);
onBeforeUnmount(() => element?.remove());
</script>
